import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface ToastMessage {
  id: number
  message: string
  type: 'success' | 'error' | 'info'
}

export const useUiStore = defineStore('ui', () => {
  const toasts = ref<ToastMessage[]>([])
  let nextId = 1

  function toast(message: string, type: ToastMessage['type'] = 'success') {
    const item = { id: nextId++, message, type }
    toasts.value.push(item)
    window.setTimeout(() => dismiss(item.id), 3200)
  }

  function dismiss(id: number) {
    toasts.value = toasts.value.filter(item => item.id !== id)
  }

  return { toasts, toast, dismiss }
})
